import { render, staticRenderFns } from "./PDFViewer.vue?vue&type=template&id=ae2f99c8"
import script from "./PDFViewer.vue?vue&type=script&lang=ts"
export * from "./PDFViewer.vue?vue&type=script&lang=ts"
import style0 from "./PDFViewer.vue?vue&type=style&index=0&id=ae2f99c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports